module.exports = __webpack_public_path__ + "static/media/tableau_de_bord.4e696e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/tableau_de_bord.jpg
// module id = ./src/statsradio/modules/tutorials/assets/tableau_de_bord.jpg
// module chunks = 18